import { generate } from '@/utils/request';
const config = {
  prefix: '/spur/v1/{organizationId}/',
  items: [
    // 采购入库单列表
    { key: 'getStockins', url: 'stockins', method: 'GET' },
    // 创建采购入库单
    { key: 'addStockins', url: 'stockins', method: 'POST' },
    // 修改采购入库单
    { key: 'putStockins', url: 'stockins', method: 'PUT' },
    // 删除采购入库单
    { key: 'deleteStockins', url: 'stockins/batch', method: 'DELETE' },
    // 采购入库单详情
    { key: 'getStockinsDetail', url: 'stockins/detail', method: 'GET' },
    // 采购入库单推送SAP
    { key: 'stockingPushSAP', url: 'stockins/pushSAP', method: 'POST' },
    // 反审采购入库
    { key: 'antiAuditStockins', url: 'stockins/anti-audit', method: 'PATCH' },
    // 审核采购入库
    { key: 'auditStockins', url: 'stockins/audit', method: 'PATCH' },
    // 取消采购入库
    { key: 'cancelStockins', url: 'stockins/cancel', method: 'PATCH' },
    // 采购入库单确定入库[采购入库结果单管理]
    {
      key: 'generateResultsByStockins',
      url: 'stockin-results/generate-results-by-stockins',
      method: 'POST',
    },
    // 采购入库单确认入库[采购入库单管理]
    { key: 'generateStockins', url: 'stockins/allStock', method: 'PUT'},
    // 采购入库单导出
    { key: 'reportStockins', url: 'stockins/report', method: 'GET', rType: 2 },
  ],
};
export default {
  ...generate(config),
};
